import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useRef } from 'react';
import Button, { ButtonSize, ButtonVariant } from './Button';
export var CardVariant;
(function (CardVariant) {
    CardVariant["ImageLeft"] = "image-left";
    CardVariant["ImageRight"] = "image-right";
    CardVariant["Full"] = "full";
    CardVariant["BioLeft"] = "bio-left";
    CardVariant["BioRight"] = "bio-right";
    CardVariant["Contact"] = "contact";
})(CardVariant || (CardVariant = {}));
export var CardColor;
(function (CardColor) {
    CardColor["Primary"] = "#3F51B5";
    CardColor["Secondary"] = "#009688";
})(CardColor || (CardColor = {}));
function Card({ variant, color, header, content, imageSrc, id, name, title, bioImageSrc, bio, onReadBio }) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const formRef = useRef(null);
    const isFull = variant === CardVariant.Full;
    const isContact = variant === CardVariant.Contact;
    const isImageLeft = variant === CardVariant.ImageLeft;
    const isImageRight = variant === CardVariant.ImageRight;
    const isBioLeft = variant === CardVariant.BioLeft;
    const isBioRight = variant === CardVariant.BioRight;
    const isBio = isBioLeft || isBioRight;
    // Parse content: if string, split by newlines; if array, use as-is
    const contentLines = typeof content === 'string'
        ? content.split('\n').filter(line => line.trim().length > 0)
        : content;
    // Modal component for bio display
    const BioModal = () => {
        if (!isModalOpen || !bio)
            return null;
        // Calculate inverse color: if card is Primary, use Secondary, and vice versa
        const modalColor = color === CardColor.Primary ? CardColor.Secondary : CardColor.Primary;
        return (_jsx(_Fragment, { children: _jsx("div", Object.assign({ style: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    zIndex: 2000,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }, onClick: () => setIsModalOpen(false) }, { children: _jsxs("div", Object.assign({ className: "bio-modal-content", style: {
                        backgroundColor: modalColor,
                        color: 'white',
                        padding: '2rem',
                        borderRadius: '8px',
                        maxWidth: '800px',
                        // maxWidth: '600px',
                        width: '90%',
                        maxHeight: '80vh',
                        overflow: 'auto',
                        position: 'relative',
                        zIndex: 2001,
                    }, onClick: (e) => e.stopPropagation() }, { children: [_jsxs("div", Object.assign({ style: {
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '1.5rem',
                            } }, { children: [_jsx("h2", Object.assign({ className: "bio-modal-header", style: {
                                        fontSize: '24pt',
                                        // fontSize: '20pt',
                                        margin: 0,
                                        fontWeight: 'normal',
                                        fontFamily: 'Cabin, sans-serif',
                                        color: 'white',
                                    } }, { children: name })), _jsx(Button, { variant: ButtonVariant.Close, content: "\u00D7", action: () => setIsModalOpen(false) })] })), _jsx("p", Object.assign({ className: "bio-modal-text", style: {
                                fontSize: '14pt',
                                // fontSize: '10pt',
                                lineHeight: '1.6',
                                margin: 0,
                                fontFamily: 'Cabin, sans-serif',
                                color: 'white',
                                whiteSpace: 'pre-wrap',
                            } }, { children: bio })), _jsx("style", { children: `
              @media (max-width: 768px) {
                .bio-modal-content {
                  padding: 1.5rem !important;
                  width: 95% !important;
                }
                .bio-modal-header {
                  font-size: 20pt !important;
                }
                .bio-modal-text {
                  font-size: 12pt !important;
                }
              }
            ` })] })) })) }));
    };
    // Bio card rendering
    if (isBio) {
        // Calculate width: (1068px - 2rem gap) / 2 to match Full card width
        const bioCardWidth = 'calc((1068px - 2rem) / 2)';
        // Calculate inverse button variant: if card is Primary, use Secondary button, and vice versa
        const buttonVariant = color === CardColor.Primary ? ButtonVariant.Secondary : ButtonVariant.Primary;
        return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "bio-card", style: {
                        width: bioCardWidth,
                        maxWidth: '100%',
                        backgroundColor: color,
                        color: 'white',
                        fontFamily: 'Cabin, sans-serif',
                        padding: '2rem',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: '1.5rem',
                        boxSizing: 'border-box',
                    } }, { children: [bioImageSrc && (_jsx("div", Object.assign({ className: "bio-image-container", style: {
                                width: '100%',
                                maxWidth: '250px',
                                height: '250px',
                                overflow: 'hidden',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            } }, { children: _jsx("img", { src: bioImageSrc, alt: name || '', style: {
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                } }) }))), _jsxs("div", Object.assign({ style: {
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                // gap: '0.5rem',
                                width: '100%',
                            } }, { children: [name && (_jsx("h3", Object.assign({ className: "bio-name", style: {
                                        fontSize: '24pt',
                                        // fontSize: '20pt',
                                        margin: 0,
                                        fontWeight: 'normal',
                                        textAlign: 'center',
                                    } }, { children: name }))), title && (_jsx("p", Object.assign({ className: "bio-title", style: {
                                        fontSize: '14pt',
                                        // fontSize: '10pt',
                                        margin: 0,
                                        textAlign: 'center',
                                    } }, { children: title })))] })), _jsx("div", Object.assign({ style: { width: '100%', display: 'flex', justifyContent: 'center' } }, { children: _jsx(Button, { variant: buttonVariant, content: "Read Bio", action: () => {
                                    setIsModalOpen(true);
                                    if (onReadBio)
                                        onReadBio();
                                }, size: ButtonSize.Large }) }))] })), _jsx(BioModal, {}), _jsx("style", { children: `
          @media (max-width: 768px) {
            .bio-card {
              width: 100% !important;
              padding: 1.5rem !important;
              min-height: auto !important;
            }
            .bio-image-container {
              maxWidth: 200px !important;
              width: 200px !important;
              height: auto !important;
              max-height: none !important;
              overflow: visible !important;
            }
            .bio-image-container img {
              object-fit: contain !important;
              width: 100% !important;
              height: auto !important;
            }
            .bio-name {
              font-size: 20pt !important;
            }
            .bio-title {
              font-size: 12pt !important;
            }
          }
          @media (max-width: 480px) {
            .bio-card {
              padding: 1rem !important;
            }
            .bio-image-container {
              maxWidth: 150px !important;
              width: 150px !important;
              height: auto !important;
              max-height: none !important;
              overflow: visible !important;
            }
            .bio-image-container img {
              object-fit: contain !important;
              width: 100% !important;
              height: auto !important;
            }
            .bio-name {
              font-size: 18pt !important;
            }
            .bio-title {
              font-size: 11pt !important;
            }
          }
        ` })] }));
    }
    if (isFull) {
        return (_jsxs("div", Object.assign({ id: id, style: {
                position: 'relative',
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '240px',
                marginBottom: '94px',
                scrollMarginTop: '100px'
            } }, { children: [_jsxs("div", Object.assign({ className: 'text-card-container', style: {
                        width: '1068px',
                        maxWidth: 'calc(100% - 2rem)',
                        backgroundColor: color,
                        color: 'white',
                        fontFamily: 'Cabin, sans-serif',
                        padding: '2rem',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '1rem',
                    } }, { children: [_jsx("h2", Object.assign({ className: "full-card-header", style: {
                                fontSize: '24pt',
                                // fontSize: '20pt',
                                margin: 0,
                                fontWeight: 'normal',
                            } }, { children: header })), contentLines.length === 1 ? (_jsx("p", Object.assign({ className: "full-card-content", style: {
                                fontSize: '14pt',
                                // fontSize: '10pt',
                                margin: 0,
                                lineHeight: '1.5',
                            } }, { children: contentLines[0] }))) : (_jsx("ul", Object.assign({ className: "full-card-content", style: {
                                fontSize: '14pt',
                                // fontSize: '10pt',
                                margin: 0,
                                paddingLeft: '1.5rem',
                                lineHeight: '1.8',
                                listStyleType: 'disc',
                            } }, { children: contentLines.map((line, index) => (_jsx("li", Object.assign({ style: { marginBottom: '0.5rem' } }, { children: line.trim() }), index))) })))] })), _jsx("style", { children: `
          @media (max-width: 768px) {
            .text-card-container {
              padding: 1.5rem !important;
            }
            .full-card-header {
              font-size: 20pt !important;
            }
            .full-card-content {
              font-size: 12pt !important;
            }
          }
          @media (max-width: 480px) {
            .text-card-container {
              padding: 1rem !important;
            }
            .full-card-header {
              font-size: 18pt !important;
            }
            .full-card-content {
              font-size: 11pt !important;
            }
          }
        ` })] })));
    }
    if (isContact) {
        const handleSubmit = (e) => {
            if (e) {
                e.preventDefault();
            }
            console.log('Email:', email);
            console.log('Message:', message);
            // Reset form
            setEmail('');
            setMessage('');
        };
        // Calculate inverse button variant: if card is Primary, use Secondary button, and vice versa
        const buttonVariant = color === CardColor.Primary ? ButtonVariant.Secondary : ButtonVariant.Primary;
        return (_jsxs("div", Object.assign({ id: id, style: {
                position: 'relative',
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '240px',
                marginBottom: '94px',
                scrollMarginTop: '100px'
            } }, { children: [_jsxs("div", Object.assign({ className: 'text-card-container contact-card', style: {
                        width: '1068px',
                        maxWidth: 'calc(100% - 2rem)',
                        backgroundColor: color,
                        color: 'white',
                        fontFamily: 'Cabin, sans-serif',
                        padding: '2rem',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '1.5rem',
                    } }, { children: [_jsx("h2", Object.assign({ className: "contact-header", style: {
                                fontSize: '24pt',
                                // fontSize: '20pt',
                                margin: 0,
                                fontWeight: 'normal',
                            } }, { children: header })), _jsxs("form", Object.assign({ ref: formRef, onSubmit: handleSubmit, style: { display: 'flex', flexDirection: 'column', gap: '1rem' } }, { children: [_jsxs("div", Object.assign({ style: { display: 'flex', flexDirection: 'column', gap: '0.5rem' } }, { children: [_jsx("label", Object.assign({ htmlFor: "contact-email", className: "contact-label", style: {
                                                fontSize: '14pt',
                                                // fontSize: '10pt',
                                                fontWeight: 'normal',
                                            } }, { children: "Email" })), _jsx("input", { type: "email", id: "contact-email", value: email, onChange: (e) => setEmail(e.target.value), required: true, className: "contact-input", style: {
                                                padding: '0.75rem',
                                                fontSize: '14pt',
                                                // fontSize: '10pt',
                                                fontFamily: 'Cabin, sans-serif',
                                                border: 'none',
                                                borderRadius: '4px',
                                                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                                color: '#000',
                                            } })] })), _jsxs("div", Object.assign({ style: { display: 'flex', flexDirection: 'column', gap: '0.5rem' } }, { children: [_jsx("label", Object.assign({ htmlFor: "contact-message", className: "contact-label", style: {
                                                fontSize: '14pt',
                                                // fontSize: '10pt',
                                                fontWeight: 'normal',
                                            } }, { children: "Message" })), _jsx("textarea", { id: "contact-message", value: message, onChange: (e) => setMessage(e.target.value), required: true, rows: 5, className: "contact-textarea", style: {
                                                padding: '0.75rem',
                                                fontSize: '14pt',
                                                // fontSize: '10pt',
                                                fontFamily: 'Cabin, sans-serif',
                                                border: 'none',
                                                borderRadius: '4px',
                                                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                                color: '#000',
                                                resize: 'vertical',
                                            } })] })), _jsx("div", Object.assign({ style: { display: 'flex', justifyContent: 'flex-end', marginTop: '0.5rem' } }, { children: _jsx(Button, { variant: buttonVariant, content: "Submit", action: () => {
                                            if (formRef.current) {
                                                formRef.current.requestSubmit();
                                            }
                                        }, size: ButtonSize.Large }) }))] }))] })), _jsx("style", { children: `
          @media (max-width: 768px) {
            .contact-card {
              padding: 1.5rem !important;
            }
            .contact-header {
              font-size: 20pt !important;
            }
            .contact-label, .contact-input, .contact-textarea {
              font-size: 12pt !important;
            }
          }
          @media (max-width: 480px) {
            .contact-card {
              padding: 1rem !important;
            }
            .contact-header {
              font-size: 18pt !important;
            }
            .contact-label, .contact-input, .contact-textarea {
              font-size: 11pt !important;
            }
          }
        ` })] })));
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: 'card-container', style: {
                    position: 'relative',
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '240px',
                    marginBottom: '94px',
                    flexDirection: 'row',
                } }, { children: [_jsxs("div", Object.assign({ className: 'text-card', style: {
                            width: '452px',
                            maxWidth: 'calc(100% - 2rem)',
                            minHeight: '312px',
                            backgroundColor: color,
                            color: 'white',
                            fontFamily: 'Cabin, sans-serif',
                            padding: '16px',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '1rem',
                            position: 'absolute',
                            left: isImageRight
                                ? 'calc(50% - 534px)' // Image on right: text card to left of centered image
                                : isImageLeft
                                    ? 'calc(50% + 59px)' // Image on left: text card to right of centered image
                                    : 'auto',
                            top: '-36px',
                            zIndex: 1,
                            alignItems: isImageLeft ? 'flex-end' : 'flex-start',
                            justifyContent: 'center',
                        } }, { children: [_jsx("h2", Object.assign({ className: 'text-card-header', style: {
                                    fontSize: '24pt',
                                    // fontSize: '20pt',
                                    margin: 0,
                                    fontWeight: 'normal',
                                    maxWidth: '217px',
                                    textAlign: isImageRight ? 'left' : isImageLeft ? 'right' : 'center',
                                } }, { children: header })), contentLines.length === 1 ? (_jsx("p", Object.assign({ className: 'text-card-content', style: {
                                    fontSize: '14pt',
                                    // fontSize: '10pt',
                                    margin: 0,
                                    lineHeight: '1.0',
                                    maxWidth: '217px',
                                    textAlign: isImageRight ? 'left' : isImageLeft ? 'right' : 'center',
                                } }, { children: contentLines[0] }))) : (_jsx("ul", Object.assign({ className: 'text-card-content', style: {
                                    fontSize: '14pt',
                                    // fontSize: '10pt',
                                    margin: 0,
                                    paddingLeft: '1.2rem',
                                    lineHeight: '1.4',
                                    maxWidth: '217px',
                                    textAlign: isImageRight ? 'left' : isImageLeft ? 'right' : 'center',
                                    listStyleType: 'disc',
                                    display: 'flex',
                                    flexDirection: 'column',
                                } }, { children: contentLines.map((line, index) => (_jsx("li", Object.assign({ style: { marginBottom: '0.3rem' } }, { children: line.trim() }), index))) })))] })), imageSrc && (_jsx("div", Object.assign({ className: 'image-card', style: {
                            width: '560px',
                            maxWidth: 'calc(100% - 2rem)',
                            height: '240px',
                            position: 'relative',
                            zIndex: 2,
                        } }, { children: _jsx("img", { src: imageSrc, alt: "", style: {
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                            } }) })))] })), _jsx("style", { children: `
        @media (max-width: 768px) {
          .card-container {
            flex-direction: column !important;
            align-items: center !important;
            gap: 1rem !important;
            margin-bottom: 2rem !important;
          }
          .text-card {
            position: relative !important;
            left: auto !important;
            top: 0 !important;
            width: calc(100% - 2rem) !important;
            max-width: 100% !important;
            min-height: auto !important;
            padding: 1.5rem !important;
            align-items: center !important;
          }
          .image-card {
            width: calc(100% - 2rem) !important;
            max-width: 100% !important;
            height: 200px !important;
          }
          .text-card-header {
            font-size: 20pt !important;
            max-width: 100% !important;
            text-align: center !important;
          }
          .text-card-content {
            font-size: 12pt !important;
            max-width: 100% !important;
            text-align: center !important;
          }
        }
        @media (max-width: 480px) {
          .text-card {
            padding: 1rem !important;
          }
          .text-card-header {
            font-size: 18pt !important;
          }
          .text-card-content {
            font-size: 11pt !important;
          }
          .image-card {
            height: 180px !important;
          }
        }
        ${isImageLeft ? `
          @media (max-width: 768px) {
            .text-card {
              order: 2 !important;
            }
            .image-card {
              order: 1 !important;
            }
          }
        ` : `
          @media (max-width: 768px) {
            .text-card {
              order: 1 !important;
            }
            .image-card {
              order: 2 !important;
            }
          }
        `}
      ` })] }));
}
export default Card;
